import { render, staticRenderFns } from "./OptionEditor.vue?vue&type=template&id=7dfb2e55&scoped=true&"
import script from "./OptionEditor.vue?vue&type=script&lang=js&"
export * from "./OptionEditor.vue?vue&type=script&lang=js&"
import style0 from "./OptionEditor.vue?vue&type=style&index=0&id=7dfb2e55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfb2e55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VTextField})
